import React, { useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import IntroConversionChart from "./smartComponents/IntroConversionChart";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "./redux/introConversionSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import NoData from "../../../components/noData/noData";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import Filters from "./smartComponents/Filters";
import { UpdateButtons } from "./smartComponents/UpdateButtons";

const IntroConversionModule = (props) => {
  const { isLoading, initialRequest, isChartLoading, error } = useSelector((state) => {
    const { isLoading, isChartLoading, error } = state.introConversion;
    return { isLoading, isChartLoading, error };
  }, shallowEqual);

  const dispatch = useDispatch();

  useEffect(() => {
    !initialRequest &&
      dispatch(actionCreators.fetchCurrentUser({ data: props, updateFilters: false }));
  }, []);

  const content = () => {
    return (
      <div>
        <div className="edit-selections-bar">
          <div className="select-box">
            <p className="offers-title">
              Offers <span>(Select 6 Max)</span>
            </p>
            <Filters />
          </div>
          <div className="select-box">
            <p className="offers-title">Date Range</p>
            <CustomDateRanges />
          </div>
          <div className="date-select-box multi">
            <p className="offers-title">Date</p>
            <DatePicker />
          </div>
          <UpdateButtons />
        </div>
        {isChartLoading ? (
          <LoadingAnimation text="Getting fresh data, this may take a moment." />
        ) : (
          <div>{error ? <NoData size="medium" /> : <IntroConversionChart />}</div>
        )}
      </div>
    );
  };
  return (
    <SectionToggle
      title={props.title}
      isLoading={isLoading}
      content={content()}
      learnMore={
        <KBLearnMore
          title={props.title}
          description="This report shows how new clients perform across their first experiences by comparing key metrics such as intros sold, conversion rates, and lifetime revenue. These insights help you evaluate early-stage retention effectiveness and identify where new clients may need stronger onboarding."
          kbUrl={ILEARN_URLS.retention.introConversion}
        />
      }
    />
  );
};

export default React.memo(IntroConversionModule);
